import MuseumsList from "./MuseumsList";

export default MuseumsList;
